import styled from "styled-components";

export const ClassicViewBar = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px 0;
`;
